module.exports = __webpack_public_path__ + "img/knu_gallery1.ffab9a55.jpg";